// extracted by mini-css-extract-plugin
export default {"copy":"Embed-module--copy--1667b"};